/**
 * 서류 마스터 관리 (/adm/doc-master)
 * ($j.Pages.Admin.DocMaster / body data-page-name="DocMaster")
 *
 * 탭 둘.
 *   ① 서류 종류 — 목록(좌) + 상세(우). 상세 안에 기간 설정 · 사진 · 쓰임 · 입력 항목
 *      (항목 한 칸을 고치는 폼은 상세 **위에 얹은 모달**이다 — 표가 뒤에 남아야 맥락이 유지된다)
 *   ② 배정표   — 대상(회사·장비·기사) 탭 × 행 = 서류 × 열 = 전 업종 + 업종 6
 *
 * 렌더는 전부 여기서 한다(Blade 는 셸만). 저장 후에는 서버 값을 다시 받아 화면과 맞춘다.
 */
import Util from '../../Common/Util';

export default class DocMaster {
    initialize() {
        this.meta = null;
        this.types = [];
        this.curType = null;      // 지금 상세에 뜬 종류 번호 (0 = 새 서류)
        this.typeFilter = '';     // 목록 칩 — '' 이면 전체

        // 종류 목록 → 상세. 단, '등록된 서류' 칸은 갤러리를 연다 (줄 선택으로 새지 않게 먼저 막는다)
        $('#dmTypeList')
            .on('click', '.dm-count', (e) => {
                e.stopPropagation();
                this._openGallery($(e.currentTarget).closest('.dm-row').data('num'), 1);
            })
            .on('click', '.dm-row', (e) => this._openType($(e.currentTarget).data('num')));
        $('#dmTypeNew').on('click', () => this._openType(0));

        // 대상 칩 — 목록을 대상별로 좁힌다 (받아둔 값을 거르는 것이라 서버를 다시 부르지 않는다)
        $('#dmTypeChips').on('click', '.dm-chip', (e) => {
            this.typeFilter = String($(e.currentTarget).data('target') ?? '');
            this._renderTypeChips();
            this._renderTypeList();
        });

        // 상세 — 저장 · 기간 스위치 · 입력 항목.
        // 상세는 모달로 뜬다(= #dmRoot 바깥). init 시점에 그 요소가 없으므로 document 에 위임한다.
        $(document)
            .off('.dmType')
            .on('click.dmType',  '#dmTypeDetail #dmTypeSave',   () => this._saveType())
            .on('change.dmType', '#dmTypeDetail [name="use_expiry"]', () => this._syncExpiry())
            .on('click.dmType',  '#dmTypeDetail .dm-field-edit', (e) => this._openField($(e.currentTarget).data('num')))
            .on('click.dmType',  '#dmTypeDetail #dmFieldNew',    () => this._openField(0))
            .on('click.dmType',  '#dmTypeDetail .dm-field-del',  (e) => this._deleteField($(e.currentTarget).data('num')))
            // 항목 폼은 상세 **위에 얹힌 모달**이라 #dmTypeDetail 밖이다 — 선택자를 그쪽에 맞춘다
            .on('click.dmType',  '#dmFieldForm #dmFieldSave',    () => this._saveField())
            .on('click.dmType',  '#dmFieldForm #dmFieldCancel',  () => $j.Ui.JBModal.close('dm-field'))
            .on('change.dmType', '#dmFieldForm [name="field_type"]', () => this._syncFieldType())
            .on('change.dmType', '#dmTypeDetail .dm-cell', (e) => this._saveAssign($(e.currentTarget)));


        // 탭 — 마스터(고치는 곳)와 검사 결과(보는 곳). 검사 결과는 **누를 때 처음 불러온다**
        // (열지도 않을 4만 건짜리 집계를 페이지 진입마다 돌릴 이유가 없다)
        $('#dmTabs').on('click', 'a', (e) => {
            e.preventDefault();
            const tab = $(e.currentTarget).data('tab');
            $('#dmTabs a').removeClass('active');
            $(e.currentTarget).addClass('active');
            $('#dmRoot .dm-pane').prop('hidden', true);
            $(`#dmRoot .dm-pane[data-pane="${tab}"]`).prop('hidden', false);
            if (tab === 'audit' && !this.$audit) this._initAuditTable();
        });
        $(document)
            .off('.dmAudit')
            .on('click.dmAudit', '#dmAuditReload',         () => this.$audit && this.$audit.ajax.reload())
            .on('click.dmAudit', '#dmAuditHead .dm-achip', (e) => {
                this.auditFilter.flag = String($(e.currentTarget).data('flag') ?? '');
                this.$audit && this.$audit.ajax.reload();
            })
            .on('change.dmAudit', '#dmAuditHead .dm-asel', () => {
                this.auditFilter.type = $('#dmAuditType').val() || '';
                this.auditFilter.host = $('#dmAuditHost').val() || '';
                this.$audit && this.$audit.ajax.reload();
            })
            .on('click.dmAudit', '#dmAuditTable tbody tr', (e) => {
                const d = this.$audit && this.$audit.row(e.currentTarget).data();
                if (d) this._openAuditPhoto(d);
            });

        this._load();
    }

    // ─────────────────────────────────────────────── 공통

    async _load() {
        try {
            const res = await $.ajax({url: '/adm/ajax/doc-master/data', type: 'get', dataType: 'json'});
            if (!res.ok) return;
            this.meta = res.meta;
            this.types = res.types;
            this._renderTypeChips();
            this._renderTypeList();
        } catch (e) {
            console.error('서류 마스터 로드 실패', e);
            Util.swalert('서류 마스터를 불러오지 못했습니다.');
        }
    }

    _esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
            ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
    }

    _opts(map, cur) {
        return Object.keys(map).map((k) =>
            `<option value="${this._esc(k)}"${String(k) === String(cur) ? ' selected' : ''}>${this._esc(map[k])}</option>`).join('');
    }

    // ─────────────────────────────────────────────── ① 서류 종류

    /** 대상 칩 — 전체 + 업체·기사·장비. 개수는 지금 받아둔 목록에서 센다 */
    _renderTypeChips() {
        const t = this.meta.targets;
        const count = (k) => this.types.filter((x) => !k || x.target_type === k).length;

        // 색은 대상마다 다르다 — 표 안의 칩(dm-tag--*)과 같은 색표를 쓴다
        const chip = (k, label) => `<button type="button"
            class="dm-chip dm-chip--${k || 'all'}${this.typeFilter === k ? ' on' : ''}"
            data-target="${this._esc(k)}">${this._esc(label)}
            <span class="dm-chip-n">${count(k)}</span></button>`;

        $('#dmTypeChips').html(
            chip('', '전체') + Object.keys(t).map((k) => chip(k, t[k])).join('')
        );
    }

    _renderTypeList() {
        const t    = this.meta.targets;
        const cats = this.meta.categories || [];
        const shown = this.types.filter((x) => !this.typeFilter || x.target_type === this.typeFilter);

        if (!shown.length) {
            return $('#dmTypeList').html('<p class="text-muted p-3 mb-0" style="font-size:13px">이 대상에 등록된 서류 종류가 없습니다.</p>');
        }

        // 전체를 볼 때만 대상이 바뀌는 자리에 머리줄을 넣는다 — 차례가 곧 정보다.
        // 칩으로 하나만 보는 중에는 머리줄이 같은 말을 되풀이하므로 넣지 않는다.
        let lastTarget = null;
        const rows = shown.map((x) => {
            let head = '';
            if (!this.typeFilter && x.target_type !== lastTarget) {
                lastTarget = x.target_type;
                head = `<tr class="dm-group"><td colspan="8">${this._esc(t[x.target_type] || x.target_type)} 서류</td></tr>`;
            }
            return head + this._typeRow(x, t, cats);
        }).join('');
        $('#dmTypeList').html(`
            <div class="dm-tablewrap">
            <table class="table table-hover table-sm mb-0 dm-table">
                <thead>
                    <tr>
                        <th class="dm-c-code">코드</th>
                        <th class="dm-c-name">이름</th>
                        <th class="dm-c-tag  text-center">대상</th>
                        <th class="dm-c-exp  text-center">유효기간</th>
                        <th class="dm-c-num  text-center">장수</th>
                        <th class="dm-c-num  text-center">입력칸</th>
                        <th class="dm-c-cnt  text-right">등록된 서류</th>
                        <th class="dm-c-assign text-center">배정</th>
                    </tr>
                </thead>
                <tbody>${rows}</tbody>
            </table>
            </div>`);
    }

    /**
     * 목록 한 줄. 대상은 칩 버튼과 **같은 색의 칩**으로 보여 목록을 훑을 때 바로 읽히게 한다.
     * 뒤쪽 칸들이 배정(전 업종 + 업종 6)이다 — 여기서 바로 고친다.
     */
    _typeRow(x, t, cats) {
        const expiry = x.use_expiry
            ? this._esc(x.expiry_label || '만료일')
            : '<span class="text-muted">안 씀</span>';
        const badges = [
            x.is_common ? '<span class="badge badge-info" title="수주하면 작업문서로 복사됩니다">공통</span>' : '',
            x.needs_masking ? '<span class="badge badge-warning" title="가린 사진만 남습니다">가림</span>' : '',
            x.is_active ? '' : '<span class="badge badge-secondary">중지</span>',
        ].filter(Boolean).join(' ');

        return `<tr class="dm-row${this.curType === x.num ? ' dm-on' : ''}" data-num="${x.num}">
            <td><code class="text-muted">${this._esc(x.code)}</code></td>
            <td class="dm-name"><b>${this._esc(x.name)}</b> ${badges}</td>
            <td class="text-center"><span class="dm-tag dm-tag--${x.target_type}">${this._esc(t[x.target_type] || x.target_type)}</span></td>
            <td class="text-center">${expiry}</td>
            <td class="text-center">${x.max_pages}장</td>
            <td class="text-center">${x.field_cnt || '<span class="text-muted">—</span>'}</td>
            <td class="text-right">${x.doc_cnt
                ? `<button type="button" class="dm-count" title="등록된 서류를 모두 봅니다">${x.doc_cnt.toLocaleString()}건</button>`
                : '<span class="text-muted">0</span>'}</td>
            <td class="dm-chipset">${this._assignChips(x, cats)}</td>
        </tr>`;
    }

    /**
     * 배정을 칩으로 — 진한 칩이 그 업종에 필수, 흐린 칩은 아니다.
     * 표에서는 **보기만** 한다. 고치는 것은 상세 모달이다 (2026-09-18) —
     * 표에 체크박스를 늘어놓으니 값을 읽으러 온 사람도 건드리게 됐다.
     */
    _assignChips(x, cats) {
        if (!x.assignable) return '<span class="text-muted">배정 안 함</span>';

        // 업종 무관이 켜져 있으면 6칸이 모두 on 으로 온다 — 따로 칩을 두지 않아도 한눈에 읽힌다
        return cats.map((c) => {
            const on = x.cells && x.cells[c] && x.cells[c].on;
            // 업종 → 색 번호는 서버 상수 G5_CARTYPE_CHIP 이 정본이다 (app/Common/constants.php).
            // 화면마다 표를 복사하면 같은 업종이 화면마다 다른 색이 된다 — 실제로 그렇게 갈려 있었다.
            const no = (G5['CARTYPE_CHIP'] || {})[c] || 0;
            return `<span class="dm-cat dm-cat--${no}${on ? ' on' : ''}">${this._esc(c)}</span>`;
        }).join('');
    }

    // ─────────────────────────────────────────────── 등록된 서류 갤러리

    /**
     * '등록된 서류 n건' → 그 종류로 들어온 서류를 모두 본다.
     * 서류 한 건이 사진 여러 장이므로 카드는 첫 장을 보이고, 누르면 전체화면 뷰어가 그 서류의 장을 넘긴다.
     *
     * 거르는 축 셋 — 서류종류(select) · 회원 · 키워드. 회원과 키워드를 **나눠 둔 이유**는
     * 한 칸에 섞으면 "김"이 회원 이름에도 서류명에도 걸려 무엇으로 찾았는지 알 수 없어서다.
     *
     * 회원칸은 **고르는 칸**이다 — 자동완성에서 고르면 `이름#번호` 가 들어가고 그 텍스트가 곧
     * 검색기준이다(숨은 번호를 두지 않는다 — 접수목록과 같은 규약). 키워드칸만 치는 대로 찾는다.
     *
     * @param {object|null} f {q, member} — 주지 않으면 지금 걸린 조건을 이어 쓴다
     */
    async _openGallery(typeNum, page, f) {
        const cur  = (this.gallery && this.gallery.type.num === typeNum) ? this.gallery : null;
        const q    = f && f.q        !== undefined ? f.q        : (cur ? cur.q        : '') || '';
        const mem  = f && f.member   !== undefined ? f.member   : (cur ? cur.member   : '') || '';
        const cat  = f && f.category !== undefined ? f.category : (cur ? cur.category : '') || '';

        try {
            const res = await $.ajax({
                url: '/adm/ajax/doc-master/docs', type: 'get',
                data: {type_num: typeNum, page, q, member: mem, category: cat}, dataType: 'json',
            });
            if (!res.ok) return Util.swalert(res.message);

            this.gallery = res;   // 뷰어가 장을 넘길 때 다시 읽는다

            if ($('#dmGalleryBody').length) {
                // 페이지 이동·검색 — 모달은 그대로 두고 목록만 갈아 끼운다.
                // **검색줄은 다시 그리지 않는다** — 그리면 타이핑 중 포커스와 커서 자리가 날아간다
                $('#dmGalleryList').html(this._galleryHtml(res));
                // 결과 수가 바뀌면 모달 높이가 바뀐다 — 열려 있던 자동완성 목록은 화면좌표로
                // 붙어 있으므로 인풋에 다시 맞춰 준다 (안 맞추면 허공에 남는다)
                $j.F.Admin.AutoComplete.repositionOpen();
                $('#dmGalleryType').val(String(res.type.num));
                $('#dmGalleryCat').html(this._catOptionsHtml(res));
                // 제목도 따라 바꾼다 — JBModal 은 setTitle 을 내놓지 않으므로(Ui.Modal 핸들에만 있다)
                // 어댑터가 붙여 둔 호환 클래스로 직접 건드린다
                $('#dmGalleryBody').closest('.jb-modal').find('.jb-modal-title')
                    .text(`${res.type.name} — 등록된 서류`);
            } else {
                $j.Ui.JBModal.html('dm-gallery', `
                    <div id="dmGalleryBody">
                        <div class="dm-gsearch">
                            <select id="dmGalleryType" class="form-control form-control-sm dm-gsel">
                                ${this._typeOptionsHtml(res)}
                            </select>
                            <select id="dmGalleryCat" class="form-control form-control-sm dm-gcat">
                                ${this._catOptionsHtml(res)}
                            </select>
                            <input type="search" id="dmGalleryMember" class="form-control form-control-sm"
                                   placeholder="회원 — 이름을 치고 목록에서 고릅니다" autocomplete="off"
                                   value="${this._esc(res.member || '')}">
                            <input type="search" id="dmGalleryQ" class="form-control form-control-sm"
                                   placeholder="차량번호 · 서류명 · 상호" value="${this._esc(res.q || '')}">
                            <button type="button" class="btn btn-secondary btn-sm" id="dmGalleryQClear">지우기</button>
                        </div>
                        <div id="dmGalleryList">${this._galleryHtml(res)}</div>
                    </div>`,
                    `${this._esc(res.type.name)} — 등록된 서류`, {width: '1100px'});
                this._bindGallery();
            }
        } catch (e) {
            Util.swalert('서류를 불러오지 못했습니다.');
        }
    }

    /** 종류 고르기 — 목록과 같은 차례(업체→기사→장비)로, 대상과 건수를 함께 보인다 */
    _typeOptionsHtml(res) {
        return (res.typeOptions || []).map((t) =>
            `<option value="${t.num}"${t.num === res.type.num ? ' selected' : ''}>`
            + `[${this._esc(t.target)}] ${this._esc(t.name)} (${t.cnt.toLocaleString()})</option>`
        ).join('');
    }

    /**
     * 업종 고르기 — 업종은 서류가 아니라 **대상**에 붙어 있다.
     * 장비 서류는 그 장비의 업종, 기사·업체 서류는 그 사람이 가진 장비의 업종으로 걸린다.
     */
    _catOptionsHtml(res) {
        const cats = (this.meta && this.meta.categories) || [];
        return `<option value="">업종 전체</option>`
            + cats.map((c) =>
                `<option value="${this._esc(c)}"${c === res.category ? ' selected' : ''}>${this._esc(c)}</option>`
              ).join('');
    }

    /** 모달 안에서만 쓰는 손잡이 — 모달을 새로 열 때 한 번만 묶는다 */
    _bindGallery() {
        const self = this;
        $(document)
            .off('.dmGal')   // 네임스페이스 전부 — click 만 떼면 input 핸들러가 겹쳐 쌓인다
            .on('click.dmGal', '#dmGalleryBody .dm-gcard', (e) => {
                const i = parseInt($(e.currentTarget).data('i'));
                const doc = this.gallery.docs[i];
                if (!doc || !doc.pages.length) return;
                $j.Ui.ZoomPhoto.open(null, {
                    // **주소는 서버가 만든 것을 그대로 준다.** path·host 만 넘기면 뷰어가 JS 로 조립하는데,
                    // JS 는 호스트 번호→도메인 표를 모른다 — `3/images/original/…` 같은 상대주소가 나와
                    // 지금 페이지(/adm/) 밑으로 붙는다. `url` 이 있으면 뷰어가 조립을 건너뛴다.
                    items: doc.pages.map((p, n) => ({
                        url: p.url,
                        caption: `${doc.name} · ${this.gallery.type.name}`,
                        meta: `${n + 1}/${doc.pages.length}장`
                            + (p.is_masked ? ' · 가림' : '')
                            + (doc.expireDate ? ` · 만료 ${doc.expireDate}` : '')
                            + ` · 등록 ${doc.createdAt}`,
                    })),
                    index: 0,
                });
            })
            .on('click.dmGal', '#dmGalleryBody .dm-gpage', (e) => {
                this._openGallery(this.gallery.type.num, parseInt($(e.currentTarget).data('p')));
            })
            // 종류를 바꾸면 거르는 조건은 그대로 두고 1쪽부터 — 같은 회원의 다른 서류를 보는 흐름이다
            .on('change.dmGal', '#dmGalleryType', (e) => {
                this._openGallery(parseInt($(e.currentTarget).val()), 1);
            })
            .on('change.dmGal', '#dmGalleryCat', (e) => {
                this._openGallery(this.gallery.type.num, 1, {category: $(e.currentTarget).val()});
            })
            // 검색 — 글자마다 부르면 6,000건짜리 조인이 그만큼 돈다. 멈춘 뒤에 한 번 부른다
            .on('input.dmGal', '#dmGalleryQ', (e) => this._laterSearch({q: $(e.currentTarget).val()}))
            // 회원칸은 **타이핑으로 검색하지 않는다** — 자동완성에서 고른 뒤에 건다 (2026-09-21).
            //
            //   전에는 한 글자마다 목록이 갈렸다. 그러면 ① "이"까지만 쳐도 6,152건이 한 번씩
            //   걸러지고, ② 결과가 줄어 모달 높이가 바뀌는데 자동완성 목록은 화면좌표로 붙어
            //   있어 인풋에서 떨어져 나갔다(실제로 목록이 모달 위쪽 허공에 떴다). ③ 무엇보다
            //   이름은 동명이인이 흔해 '고른 사람'이 아니면 찾는 사람이 아니다.
            //
            //   비우는 것만은 바로 반영한다 — 빈 칸이 보이는데 결과가 걸러진 채면 화면이
            //   거짓말을 한다(검색칸에 숨은 상태를 두지 않는다는 규약).
            .on('input.dmGal', '#dmGalleryMember', (e) => {
                if ($(e.currentTarget).val().trim() !== '') return;
                clearTimeout(this._qTimer);
                if (!this.gallery || !this.gallery.member) return;
                this._openGallery(this.gallery.type.num, 1, {member: ''});
            })
            .on('keydown.dmGal', '#dmGalleryQ, #dmGalleryMember', (e) => {
                if (e.key !== 'Enter') return;
                // 자동완성 목록에서 고른 엔터는 onSelect 가 이미 검색했다 — 여기서 또 부르면
                // 같은 검색이 두 번 돈다. (AutoComplete 가 인풋에 직접 물려 있어 먼저 받는다)
                if (this._acPicked) { this._acPicked = false; return; }
                clearTimeout(this._qTimer);
                this._openGallery(this.gallery.type.num, 1,
                    {q: $('#dmGalleryQ').val(), member: $('#dmGalleryMember').val()});
            })
            .on('click.dmGal', '#dmGalleryQClear', () => {
                clearTimeout(this._qTimer);
                $('#dmGalleryQ').val('');
                $('#dmGalleryMember').val('');
                $('#dmGalleryCat').val('');
                this._openGallery(this.gallery.type.num, 1, {q: '', member: '', category: ''});
            });

        // 회원칸 자동완성 — 관리자 공용 모듈. 고르면 "이름#번호" 가 들어가고
        // 그 텍스트가 곧 검색기준이다(숨은 번호를 두지 않는다 — 접수목록과 같은 규약).
        $j.F.Admin.AutoComplete.init({
            id: 'dmGalleryMember', v: '', d: '',
            onSelect: function (id, $li) {
                $('#dmGalleryMember').val(`${$li.data('name')}#${$li.data('num')}`);
                clearTimeout(self._qTimer);
                // 엔터로 골랐다면 버블링된 keydown 이 곧바로 뒤따른다 — 그 한 번만 건너뛰게 표를 남긴다.
                // 마우스로 골랐을 땐 뒤따르는 엔터가 없으므로 다음 틱에 스스로 지운다.
                self._acPicked = true;
                setTimeout(() => { self._acPicked = false; }, 0);
                self._openGallery(self.gallery.type.num, 1, {member: $('#dmGalleryMember').val()});
            },
            onFind: function () {},   // 이름만 친 상태도 유효한 검색이다 — 번호로 바꾸지 않는다
            onRender: function (row) {
                const tpl = `<li class="ac-list-group-item" data-num="{num}" data-name="{mem_name}">{mem_name}#{num} <span style="color:#888">{mem_phone}</span></li>`;
                return Util.render_template(tpl, row);
            },
        });
    }

    /** 배정 체크 상태를 서버 값에 맞춘다 — 모달을 통째로 다시 그리면 스크롤이 튄다 */
    _syncAssignBox() {
        const cells = this.detail.cells || {};
        $('#dmTypeDetail .dm-assignbox .dm-cell').each((i, el) => {
            const $el = $(el);
            const c = String($el.data('cat') ?? '');
            const v = cells[c] || {on: false, byAll: false};
            $el.prop('checked', !!v.on);
            $el.closest('.dm-chk')
               .toggleClass('dm-byall', !!v.byAll)
               .attr('title', v.byAll ? '업종 무관이 켜져 있어 모든 업종이 필수입니다' : '');
        });
    }

    /** 타이핑이 멈춘 뒤 한 번만 부른다 */
    _laterSearch(f) {
        clearTimeout(this._qTimer);
        this._qTimer = setTimeout(() => this._openGallery(this.gallery.type.num, 1, f), 300);
    }

    _galleryHtml(res) {
        const pages = Math.ceil(res.total / res.perPage) || 1;
        const from  = (res.page - 1) * res.perPage + 1;
        const to    = Math.min(res.page * res.perPage, res.total);

        if (!res.docs.length) {
            const what = [
                res.category ? `업종 ‘${this._esc(res.category)}’` : '',
                res.member   ? `회원 ‘${this._esc(res.member)}’`   : '',
                res.q        ? `‘${this._esc(res.q)}’`             : '',
            ].filter(Boolean).join(' · ');
            return `<p class="text-muted mb-0 p-3">${what ? what + ' 로 찾은 서류가 없습니다.' : '등록된 서류가 없습니다.'}</p>`;
        }

        const cards = res.docs.map((d, i) => {
            const first = d.pages[0];
            // 사진 자리는 **늘 깔아 둔다.** 그 위에 사진을 얹고, 사진이 없거나 파일이 사라졌으면
            // (g5_file 행은 있는데 실물이 없는 경우가 있다) 사진만 감춰 이 자리가 드러나게 한다.
            // loading="lazy" 라 눈에 들어올 때 받는다 — 60장을 한꺼번에 받지 않는다.
            const thumb = `<div class="dm-gnone">${first ? '사진 깨짐' : '사진 없음'}</div>`
                + (first
                    ? `<img src="${this._esc(first.thumb)}" alt="" loading="lazy" decoding="async"
                            onerror="this.remove()">`
                    : '');

            const badges = [
                d.pages.length > 1 ? `<span class="dm-gbadge">${d.pages.length}장</span>` : '',
                d.expired ? '<span class="dm-gbadge dm-gbadge--over">만료</span>' : '',
                first && first.is_masked ? '<span class="dm-gbadge">가림</span>' : '',
            ].filter(Boolean).join('');

            return `<div class="dm-gcard" data-i="${i}">
                <div class="dm-gthumb">${thumb}${badges ? `<div class="dm-gbadges">${badges}</div>` : ''}</div>
                <div class="dm-gname" title="${this._esc(d.name)}">${this._esc(d.name)}</div>
                <div class="dm-gmeta">${this._esc(d.sub)}${d.title ? ' · ' + this._esc(d.title) : ''}</div>
                <div class="dm-gmeta">${this._esc(d.ownerName)}${d.expireDate ? ' · ~' + this._esc(d.expireDate) : ''}</div>
            </div>`;
        }).join('');

        return `<div class="dm-grid">${cards}</div>
            ${this._galleryNav(res, pages, from, to)}`;
    }

    /**
     * 페이징 — DataTables v2 의 `paging_full_numbers` 를 따른다 (처음·이전·번호·다음·마지막 + 건수 안내).
     * 클래스도 벤더 것을 그대로 쓴다(dt-paging / dt-paging-button / current / disabled) —
     * 관리자 다른 표와 모양·다크 대응이 갈리지 않게 하려는 것이다.
     *
     * 번호는 **한 번에 10개**를 지금 쪽 둘레로 보인다. 1·2쪽에서는 1~10, 끝쪽에서는 마지막 10개다.
     */
    _galleryNav(res, pages, from, to) {
        const info = `<div class="dt-info" role="status">
            ${res.total.toLocaleString()}건 중 ${res.total ? from.toLocaleString() : 0}–${to.toLocaleString()}
        </div>`;
        if (pages <= 1) return `<div class="dm-gfoot">${info}</div>`;

        const WIN = 10;
        let start = Math.max(1, res.page - Math.floor(WIN / 2));
        let end   = Math.min(pages, start + WIN - 1);
        start     = Math.max(1, end - WIN + 1);   // 끝쪽에서도 10개를 채운다

        const btn = (label, p, cls) => {
            const off = p < 1 || p > pages || p === res.page;
            // 못 가는 버튼은 자리를 지키되 눌리지 않는다 — 사라지면 버튼 줄이 움찔거린다
            return `<button type="button" class="dt-paging-button ${cls}${off && cls.indexOf('current') < 0 ? ' disabled' : ''}"
                ${off ? 'disabled' : `data-p="${p}"`}>${label}</button>`;
        };

        let body = '';
        for (let p = start; p <= end; p++) {
            body += btn(p, p, p === res.page ? 'dm-gpage current' : 'dm-gpage');
        }

        return `<div class="dm-gfoot">
            ${info}
            <div class="dt-paging paging_full_numbers">
                ${btn('«', 1, 'dm-gpage first')}
                ${btn('‹', res.page - 1, 'dm-gpage previous')}
                ${start > 1 ? '<span class="dt-paging-button ellipsis disabled">…</span>' : ''}
                ${body}
                ${end < pages ? '<span class="dt-paging-button ellipsis disabled">…</span>' : ''}
                ${btn('›', res.page + 1, 'dm-gpage next')}
                ${btn('»', pages, 'dm-gpage last')}
            </div>
        </div>`;
    }


    async _openType(num) {
        this.curType = num;
        $('#dmTypeList .dm-row').removeClass('dm-on');
        $(`#dmTypeList .dm-row[data-num="${num}"]`).addClass('dm-on');

        if (!num) {
            this.detail = {
                num: 0, code: '', name: '', target_type: 'car', use_expiry: 0,
                expiry_label: '', expiry_help: '', max_pages: 1, needs_masking: 0,
                is_common: 0, guide: '', is_active: 1, sort_no: 0, legacy_code: null,
                doc_cnt: 0, fields: [], warnings: [],
            };
            return this._renderDetail();
        }

        try {
            const res = await $.ajax({url: '/adm/ajax/doc-master/type', type: 'get', data: {num}, dataType: 'json'});
            if (!res.ok) return Util.swalert(res.message);
            this.detail = res.type;
            this._renderDetail();
        } catch (e) {
            Util.swalert('서류 종류를 불러오지 못했습니다.');
        }
    }

    _renderDetail() {
        const d = this.detail;
        const m = this.meta;
        const isNew = !d.num;
        const lockTarget = d.doc_cnt > 0;

        const warn = (d.warnings || []).map((w) =>
            `<div class="dm-warn"><i class="fas fa-exclamation-triangle"></i> ${this._esc(w)}</div>`).join('');

        const title = isNew ? '새 서류'
            : `${this._esc(d.name)} <small class="text-muted">${this._esc(d.code)}${d.legacy_code ? ' · 옛 코드 ' + this._esc(d.legacy_code) : ''}</small>`;
        this._detailToModal(title, `
            ${warn}
            <div class="form-row">
                ${isNew ? `
                <div class="form-group col-5 mb-2">
                    <label class="col-form-label-sm mb-0">코드 <small class="text-muted">(바뀌지 않음)</small></label>
                    <input type="text" name="code" class="form-control form-control-sm" placeholder="safety_cert">
                </div>` : ''}
                <div class="form-group col mb-2">
                    <label class="col-form-label-sm mb-0">이름</label>
                    <input type="text" name="name" class="form-control form-control-sm"
                           value="${this._esc(d.name)}" maxlength="45">
                </div>
                <div class="form-group col-4 mb-2">
                    <label class="col-form-label-sm mb-0">대상${lockTarget ? ' <small class="text-muted">(잠김)</small>' : ''}</label>
                    <select name="target_type" class="form-control form-control-sm"${lockTarget ? ' disabled' : ''}>
                        ${this._opts(m.targets, d.target_type)}
                    </select>
                </div>
                <div class="form-group col-3 mb-2">
                    <label class="col-form-label-sm mb-0">순서</label>
                    <input type="number" name="sort_no" class="form-control form-control-sm"
                           value="${d.sort_no}" min="0" max="9999">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-3 mb-2">
                    <label class="col-form-label-sm mb-0">최대 장수</label>
                    <input type="number" name="max_pages" class="form-control form-control-sm"
                           value="${d.max_pages}" min="1" max="99">
                </div>
                <div class="form-group col mb-2">
                    <label class="col-form-label-sm mb-0">스위치</label>
                    <div class="dm-switches">
                        <label class="dm-chk"><input type="checkbox" name="use_expiry" ${d.use_expiry ? 'checked' : ''}><span>유효기간</span></label>
                        <label class="dm-chk"><input type="checkbox" name="needs_masking" ${d.needs_masking ? 'checked' : ''}><span>가림 대상</span></label>
                        <label class="dm-chk"><input type="checkbox" name="is_common" ${d.is_common ? 'checked' : ''}><span>공통서류</span></label>
                        <label class="dm-chk"><input type="checkbox" name="is_active" ${d.is_active ? 'checked' : ''}><span>사용</span></label>
                    </div>
                </div>
            </div>

            <div class="form-row" id="dmExpiryBox"${d.use_expiry ? '' : ' hidden'}>
                <div class="form-group col-4 mb-2">
                    <label class="col-form-label-sm mb-0">기간 칸 이름</label>
                    <input type="text" name="expiry_label" class="form-control form-control-sm"
                           value="${this._esc(d.expiry_label)}" maxlength="30" placeholder="만료일">
                </div>
                <div class="form-group col mb-2">
                    <label class="col-form-label-sm mb-0">기간 칸 안내</label>
                    <input type="text" name="expiry_help" class="form-control form-control-sm"
                           value="${this._esc(d.expiry_help)}" maxlength="100" placeholder="2년마다 새로 받습니다">
                </div>
            </div>

            <div class="form-group mb-2">
                <label class="col-form-label-sm mb-0">회원 안내 · 인정 서류</label>
                <input type="text" name="guide" class="form-control form-control-sm" maxlength="300"
                       value="${this._esc(d.guide)}" placeholder="이 서류로 낼 수 있는 것 — 재직증명서 · 경력확인서">
            </div>

            ${isNew || !d.assignable ? '' : `
                <hr class="my-2">
                <div class="dm-sub">배정 — 어느 업종에 필수인가</div>
                <p class="text-muted mb-2" style="font-size:12px">
                    <b>업종 무관</b>을 켜면 모든 업종에 필수입니다. 업종을 하나라도 켜면 업종 무관은 꺼집니다
                    — 둘은 섞이지 않습니다.
                </p>
                <div class="dm-assignbox">
                    <label class="dm-chk dm-chk--all">
                        <input type="checkbox" class="dm-cell" data-type="${d.num}" data-cat=""
                               ${d.cells && d.cells[''] && d.cells[''].on ? 'checked' : ''}>
                        <span>업종 무관</span>
                    </label>
                    ${(m.categories || []).map((c) => {
                        const cell = (d.cells && d.cells[c]) || {on: false, byAll: false};
                        return `<label class="dm-chk${cell.byAll ? ' dm-byall' : ''}"
                                       title="${cell.byAll ? '업종 무관이 켜져 있어 모든 업종이 필수입니다' : ''}">
                            <input type="checkbox" class="dm-cell" data-type="${d.num}" data-cat="${this._esc(c)}"
                                   ${cell.on ? 'checked' : ''}>
                            <span>${this._esc(c)}</span>
                        </label>`;
                    }).join('')}
                </div>
                <div id="dmImpactBox"></div>`}

            ${isNew ? '' : `
                <hr class="my-2">
                <div class="dm-sub d-flex align-items-center">
                    입력 항목
                    <button type="button" class="btn btn-outline-primary btn-xs ml-auto" id="dmFieldNew">+ 항목</button>
                </div>
                <p class="text-muted mb-2" style="font-size:12px">
                    회원 입력폼 · 관리자 대조 · 공유 화면이 이 정의 하나로 그려집니다.
                    유효기간은 여기 넣지 않습니다 — 위 기간 설정이 정본입니다.
                </p>
                <div id="dmFieldBox"></div>`}

            <div class="dm-savebar">
                <button type="button" class="btn btn-primary btn-sm" id="dmTypeSave">저장</button>
            </div>

        `);

        if (d.num) this._renderFieldList();
    }

    /**
     * 상세를 모달에 담는다.
     *
     * 좌우 카드로 나눠 두던 것을 모달로 옮겼다 (2026-09-18) — 목록이 전폭이 되어
     * 배정·등록건수까지 한 줄에 들어온다. 이미 열려 있으면 **안쪽만** 갈아 끼운다.
     */
    _detailToModal(title, html) {
        if ($('#dmTypeDetail').length) {
            $('#dmTypeDetail').html(html);
            // JBModal 은 setTitle 을 내놓지 않는다(Ui.Modal 핸들에만 있다) — 호환 클래스로 직접 바꾼다
            $('#dmTypeDetail').closest('.jb-modal').find('.jb-modal-title').html(title);
            return;
        }
        $j.Ui.JBModal.html('dm-type', `<div id="dmTypeDetail">${html}</div>`, title, {width: '640px'});
    }

    _syncExpiry() {
        $('#dmExpiryBox').prop('hidden', !$('#dmTypeDetail [name="use_expiry"]').is(':checked'));
    }

    async _saveType() {
        const $d = $('#dmTypeDetail');
        const type = {
            num: this.detail.num,
            code: $d.find('[name="code"]').val() || this.detail.code,
            name: $d.find('[name="name"]').val(),
            target_type: $d.find('[name="target_type"]').is(':disabled')
                ? this.detail.target_type : $d.find('[name="target_type"]').val(),
            use_expiry: $d.find('[name="use_expiry"]').is(':checked') ? 1 : 0,
            expiry_label: $d.find('[name="expiry_label"]').val(),
            expiry_help: $d.find('[name="expiry_help"]').val(),
            max_pages: $d.find('[name="max_pages"]').val(),
            needs_masking: $d.find('[name="needs_masking"]').is(':checked') ? 1 : 0,
            is_common: $d.find('[name="is_common"]').is(':checked') ? 1 : 0,
            guide: $d.find('[name="guide"]').val(),
            is_active: $d.find('[name="is_active"]').is(':checked') ? 1 : 0,
            sort_no: $d.find('[name="sort_no"]').val(),
        };

        try {
            const res = await $.ajax({url: '/adm/ajax/doc-master/type/save', type: 'post', data: {type}, dataType: 'json'});
            if (!res.ok) return Util.swalert(res.message);
            $j.Ui.Toast.show(res.message);
            await this._load();
            this._openType(res.num);
        } catch (e) {
            Util.swalert('저장하지 못했습니다.');
        }
    }

    // ─────────────────────────────────────────────── 입력 항목

    _renderFieldList() {
        const m = this.meta;
        const rows = (this.detail.fields || []).map((f) => `
            <tr${f.is_active ? '' : ' class="text-muted"'}>
                <td><code>${this._esc(f.field_key)}</code></td>
                <td>${this._esc(f.label)}
                    ${f.is_required ? '<span class="badge badge-danger">필수</span>' : ''}
                    ${f.is_private ? '<span class="badge badge-secondary" title="목록·공유에서 가려 보입니다">개인정보</span>' : ''}
                    ${f.is_active ? '' : '<span class="badge badge-light">중지</span>'}</td>
                <td>${this._esc(m.fieldTypes[f.field_type] || f.field_type)}</td>
                <td>${f.role ? this._esc(m.roles[f.role] || f.role) : '<span class="text-muted">—</span>'}</td>
                <td class="text-right">
                    <button type="button" class="btn btn-outline-secondary btn-xs dm-field-edit" data-num="${f.num}">고치기</button>
                    <button type="button" class="btn btn-outline-danger btn-xs dm-field-del" data-num="${f.num}">지우기</button>
                </td>
            </tr>`).join('');

        $('#dmFieldBox').html(rows
            ? `<table class="table table-sm table-bordered dm-table mb-0">
                 <thead><tr><th style="width:110px">구분값</th><th>이름</th>
                   <th style="width:90px">종류</th><th style="width:150px">역할</th>
                   <th style="width:130px"></th></tr></thead>
                 <tbody>${rows}</tbody></table>`
            : '<p class="text-muted mb-0" style="font-size:13px">받을 칸이 없습니다. 사진만 받는 서류입니다.</p>');
    }

    /**
     * 입력 항목 한 칸 — **상세 모달 위에 얇은 모달**로 연다 (2026-09-21).
     *
     * 전에는 표 자리(#dmFieldBox)를 폼으로 갈아 끼웠다. 표가 사라지고 열두 칸짜리 폼이
     * 솟으면서 모달 높이가 크게 뛰어, 어느 항목을 고치는 중인지도 어디를 보고 있었는지도
     * 놓쳤다. 게다가 종류의 [저장]과 항목의 [항목 저장]이 한 화면에 겹쳐 무엇이 저장되는지
     * 흐렸다. 모달을 하나 더 얹으면 뒤에 표가 그대로 남아 맥락이 유지되고, 저장 단위도
     * 모달 단위로 갈린다. (스택 z-index 는 $j.Ui.Layer 가 준다 — ESC 는 위쪽만 닫는다)
     */
    _openField(num) {
        const f = num
            ? (this.detail.fields || []).find((x) => x.num === num)
            : {num: 0, field_key: '', label: '', field_type: 'text', role: '', input_mode: 'manual',
               is_required: 0, is_private: 0, sort_no: 0, width: 'full', help: '', placeholder: '',
               options: '', is_active: 1};
        if (!f) return;

        const m = this.meta;
        const isNew = !f.num;

        const title = isNew
            ? '새 입력 항목'
            : `입력 항목 — ${this._esc(f.label || f.field_key)} <small class="text-muted">${this._esc(f.field_key)}</small>`;

        this._fieldToModal(title, `
            <div class="dm-fieldform" data-num="${f.num}">
                <div class="form-row">
                    <div class="form-group col-5 mb-2">
                        <label class="col-form-label-sm mb-0">구분값</label>
                        ${isNew
                            ? `<input type="text" name="field_key" class="form-control form-control-sm" placeholder="biz_no">`
                            : `<input type="text" class="form-control form-control-sm" value="${this._esc(f.field_key)}" readonly>`}
                        ${isNew ? '<small class="text-muted">바뀌지 않습니다 — 저장된 값의 열쇠입니다.</small>' : ''}
                    </div>
                    <div class="form-group col-7 mb-2">
                        <label class="col-form-label-sm mb-0">이름</label>
                        <input type="text" name="label" class="form-control form-control-sm"
                            value="${this._esc(f.label)}" maxlength="45">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-5 mb-2">
                        <label class="col-form-label-sm mb-0">종류</label>
                        <select name="field_type" class="form-control form-control-sm">${this._opts(m.fieldTypes, f.field_type)}</select>
                    </div>
                    <div class="form-group col-7 mb-2">
                        <label class="col-form-label-sm mb-0">역할</label>
                        <select name="role" class="form-control form-control-sm">${this._opts(m.roles, f.role)}</select>
                    </div>
                </div>
                <div class="form-group mb-2" id="dmOptRow"${f.field_type === 'select' ? '' : ' hidden'}>
                    <label class="col-form-label-sm mb-0">고를 값 (콤마로 구분)</label>
                    <input type="text" name="options" class="form-control form-control-sm"
                        value="${this._esc(f.options)}" maxlength="300" placeholder="1종보통,1종대형,특수">
                </div>
                <div class="form-row">
                    <div class="form-group col-6 mb-2">
                        <label class="col-form-label-sm mb-0">입력 방법</label>
                        <select name="input_mode" class="form-control form-control-sm">${this._opts(m.inputModes, f.input_mode)}</select>
                    </div>
                    <div class="form-group col-3 mb-2">
                        <label class="col-form-label-sm mb-0">칸 폭</label>
                        <select name="width" class="form-control form-control-sm">${this._opts(m.widths, f.width)}</select>
                    </div>
                    <div class="form-group col-3 mb-2">
                        <label class="col-form-label-sm mb-0">순서</label>
                        <input type="number" name="sort_no" class="form-control form-control-sm" value="${f.sort_no}" min="0" max="9999">
                    </div>
                </div>
                <div class="form-group mb-2">
                    <label class="col-form-label-sm mb-0">도움말</label>
                    <input type="text" name="help" class="form-control form-control-sm"
                        value="${this._esc(f.help)}" maxlength="100" placeholder="하이픈 없이 10자리">
                </div>
                <div class="form-group mb-2">
                    <label class="col-form-label-sm mb-0">예시 글</label>
                    <input type="text" name="placeholder" class="form-control form-control-sm"
                        value="${this._esc(f.placeholder)}" maxlength="60">
                </div>
                <div class="mb-2">
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="dmFReq" name="is_required" ${f.is_required ? 'checked' : ''}>
                        <label class="custom-control-label" for="dmFReq">필수</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="dmFPriv" name="is_private" ${f.is_private ? 'checked' : ''}>
                        <label class="custom-control-label" for="dmFPriv">개인정보 (가려 보임)</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="dmFAct" name="is_active" ${f.is_active ? 'checked' : ''}>
                        <label class="custom-control-label" for="dmFAct">사용</label>
                    </div>
                </div>
            </div>
            <div class="dm-savebar">
                <button type="button" class="btn btn-secondary btn-sm" id="dmFieldCancel">취소</button>
                <button type="button" class="btn btn-primary btn-sm" id="dmFieldSave">항목 저장</button>
            </div>`);
    }

    /** 항목 모달 — 이미 떠 있으면 안쪽만 갈아 끼운다 (상세 모달과 같은 방식) */
    _fieldToModal(title, html) {
        if ($('#dmFieldForm').length) {
            $('#dmFieldForm').html(html);
            $('#dmFieldForm').closest('.jb-modal').find('.jb-modal-title').html(title);
            return;
        }
        $j.Ui.JBModal.html('dm-field', `<div id="dmFieldForm">${html}</div>`, title, {width: '560px'});
    }

    _syncFieldType() {
        $('#dmFieldForm #dmOptRow').prop('hidden', $('#dmFieldForm [name="field_type"]').val() !== 'select');
    }

    async _saveField() {
        const $f = $('#dmFieldForm .dm-fieldform');
        const cur = parseInt($f.data('num')) || 0;
        const field = {
            num: cur,
            type_num: this.detail.num,
            field_key: $f.find('[name="field_key"]').val() || '',
            label: $f.find('[name="label"]').val(),
            field_type: $f.find('[name="field_type"]').val(),
            role: $f.find('[name="role"]').val(),
            input_mode: $f.find('[name="input_mode"]').val(),
            width: $f.find('[name="width"]').val(),
            sort_no: $f.find('[name="sort_no"]').val(),
            help: $f.find('[name="help"]').val(),
            placeholder: $f.find('[name="placeholder"]').val(),
            options: $f.find('[name="options"]').val() || '',
            is_required: $f.find('[name="is_required"]').is(':checked') ? 1 : 0,
            is_private: $f.find('[name="is_private"]').is(':checked') ? 1 : 0,
            is_active: $f.find('[name="is_active"]').is(':checked') ? 1 : 0,
        };

        try {
            const res = await $.ajax({url: '/adm/ajax/doc-master/field/save', type: 'post', data: {field}, dataType: 'json'});
            if (!res.ok) return Util.swalert(res.message);
            $j.Ui.Toast.show(res.message);
            $j.Ui.JBModal.close('dm-field');
            await this._refreshFields();
        } catch (e) {
            Util.swalert('저장하지 못했습니다.');
        }
    }

    /**
     * 항목 표만 다시 그린다 — 상세 모달은 건드리지 않는다.
     *
     * 전에는 저장 뒤 상세를 통째로 다시 그렸다(_openType). 그러면 스크롤이 맨 위로 튀고
     * 기간·배정까지 새로 그려져, 방금 고친 곳이 눈에서 사라졌다. 항목 저장이 바꾼 것은
     * 표 하나뿐이므로 그 한 조각만 갈아 끼운다.
     */
    async _refreshFields() {
        const num = this.detail?.num;
        if (!num) return;
        try {
            const res = await $.ajax({url: '/adm/ajax/doc-master/type', type: 'get', data: {num}, dataType: 'json'});
            if (res.ok) {
                this.detail.fields = res.type.fields || [];
                this._renderFieldList();
            }
        } catch (e) {
            // 표가 잠깐 낡는 것은 다음에 열 때 맞는다 — 저장은 이미 끝났으므로 경고까지 띄우지 않는다
        }
        this._load();   // 목록의 항목 수·칩도 따라 바뀐다 (모달 뒤라 눈에는 안 띈다)
    }

    _deleteField(num) {
        $j.Ui.Dialog.confirm('이 입력 항목을 지울까요? 이미 값을 받았으면 지우지 않고 사용 중지합니다.').then(async (ok) => {
            if (!ok) return;
            try {
                const res = await $.ajax({url: '/adm/ajax/doc-master/field/delete', type: 'post', data: {num}, dataType: 'json'});
                if (!res.ok) return Util.swalert(res.message);
                $j.Ui.Toast.show(res.message);
                await this._refreshFields();
            } catch (e) {
                Util.swalert('지우지 못했습니다.');
            }
        });
    }

    async _saveAssign($sel) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/doc-master/assignment/save', type: 'post',
                data: {type_num: $sel.data('type'), category: $sel.data('cat'),
                       on: $sel.is(':checked') ? 1 : 0},
                dataType: 'json',
            });
            if (!res.ok) { Util.swalert(res.message); return this._openType(this.detail.num); }
            $j.Ui.Toast.show(res.message);

            // 업종 무관과 업종별이 서로를 지우므로 화면이 혼자 계산할 수 없다 — 서버가 준 칸으로 맞춘다
            this.detail.cells = res.cells;
            this._syncAssignBox();
            this._load();   // 표의 칩도 따라 바뀐다

            // 켤 때만 영향을 보여준다 — 끄는 것은 요구를 줄이는 쪽이라 미충족이 생기지 않는다
            if ($sel.is(':checked')) this._impact($sel, String($sel.data('cat') ?? ''));
            else $('#dmImpactBox').empty();
        } catch (e) {
            Util.swalert('저장하지 못했습니다.');
        }
    }

    /**
     * 이 배정을 바꾸면 몇이 걸리나.
     *
     * 업종을 주면 그 업종 대상만 센다 — 업종별 배정이 생긴 뒤로 전 업종 기준으로만 세면
     * "스카이에 필수로 걸면 몇 대가 미충족인가"를 알 수 없다 (2026-09-18).
     */
    async _impact($btn, category) {
        const typeNum = $btn.data('type');
        const cat = category || '';
        try {
            const res = await $.ajax({
                url: '/adm/ajax/doc-master/assignment/impact', type: 'get',
                data: {type_num: typeNum, category: cat}, dataType: 'json',
            });
            if (!res.ok) return Util.swalert(res.message);
            const i = res.impact;
            const pct = i.total ? Math.round(i.has / i.total * 100) : 0;
            $('#dmImpactBox').html(`
                <div class="dm-impactbox">
                    <b>${this._esc(i.name)}</b>${cat ? ` <span class="dm-tag dm-tag--car">${this._esc(cat)}</span>` : ' <span class="text-muted">(전 업종)</span>'}
                    — 지금 ${this._esc(i.unit)} ${i.total.toLocaleString()}곳 중
                    <span class="text-success">${i.has.toLocaleString()}곳이 냈고(${pct}%)</span>
                    <span class="text-danger">${i.missing.toLocaleString()}곳이 없습니다.</span>
                    <div class="text-muted mt-1" style="font-size:12px">
                        필수로 바꾸면 그 ${i.missing.toLocaleString()}곳이 미충족이 됩니다.
                        지금 등록된 서류만 셉니다 — 심사(승인 여부)는 아직 없습니다.
                    </div>
                </div>`);
        } catch (e) {
            Util.swalert('영향을 계산하지 못했습니다.');
        }
    }

    // ─────────────────────────────────────────────── ② 사진 검사 결과

    /** 판정값 — 서버(App\Services\Doc\DocAuditService)와 같은 숫자다 */
    static get V() { return {UNKNOWN: 0, OK: 1, SUSPECT: 2, VIOLATION: 3}; }

    /**
     * 목록은 **서버사이드 DataTables** 다.
     *
     * 4만 장이 쌓이는 표라 한 번에 받을 수 없고, 쪽 넘기기·건수 표시를 직접 그리면
     * 관리자 다른 목록과 모양이 갈린다. 거르는 값(칩·셀렉트)은 `data` 로 실어 보낸다.
     */
    _initAuditTable() {
        const self = this;
        this.auditFilter = {type: '', flag: '', host: ''};

        this.$audit = new DataTable('#dmAuditTable', {
            autoWidth: false,
            processing: true, serverSide: true, ordering: false,
            pageLength: 30, lengthChange: false, searching: false,
            // 목록을 받을 때마다 요약도 같이 온다 — 따로 조회하지 않는다 (Tasks 화면과 같은 방식)
            ajax: {
                url: '/adm/ajax/doc-master/audits', type: 'post',
                dataSrc: (json) => { self._renderAuditHead(json); return json.data; },
                data: (d) => {
                    d.type = self.auditFilter.type;
                    d.flag = self.auditFilter.flag;
                    d.host = self.auditFilter.host;
                },
            },
            columns: this._auditColumns(),
            // 검사 못 한 줄은 톤을 낮춘다 — 판정이 없는 줄이라 같은 무게로 읽히면 안 된다
            createdRow: (tr, d) => {
                if (d.status !== 1) tr.classList.add('is-failed');
                // 사진이 사라진 줄도 같은 톤으로 — 지금 확인할 수 없는 줄이라는 뜻이다
                else if (!d.thumb) tr.classList.add('is-gone');
            },
            // 사진이 뜨면 자리표시를 걷고, 못 불러오면 그렇게 적는다 (위 주석 참고)
            drawCallback: () => {
                $('#dmAuditTable tbody .dm-athumb--wait > img').each(function () {
                    const $box = $(this).parent();
                    const done = () => $box.removeClass('dm-athumb--wait');
                    if (this.complete && this.naturalWidth) return done();
                    this.onload  = done;
                    this.onerror = () => $box.replaceWith('<span class="dm-anoimg">사진 못 불러옴</span>');
                });
            },
            language: {
                emptyTable: '해당하는 장이 없습니다.', loadingRecords: '불러오는 중…',
                zeroRecords: '해당하는 장이 없습니다.', info: '_START_–_END_ / _TOTAL_건',
                infoEmpty: '0건', infoFiltered: '', processing: '불러오는 중…',
                paginate: { previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>" },
            },
        });
    }

    /**
     * 요약 + 거르는 칩 — 목록 응답에 함께 실려 온다.
     *
     * **진행률을 맨 앞에 둔다.** "가림 누락 303건"만 보면 많아 보이는데, 그것이 700장 중
     * 303건인지 4만 장 중 303건인지에 따라 읽는 사람의 판단이 완전히 달라진다.
     */
    _renderAuditHead(res) {
        const f = this.auditFilter || {};
        const sum = res.summary || {};
        const s = sum.stat || {};
        const n = (v) => Number(v || 0).toLocaleString();
        const pct = sum.target ? Math.round(s.checked / sum.target * 1000) / 10 : 0;

        const chip = (key, label, cnt, tone) => `
            <button type="button" class="dm-achip${(f.flag || '') === key ? ' on' : ''}${tone ? ' dm-achip--' + tone : ''}"
                    data-flag="${key}">${label}<span class="dm-achip-n">${n(cnt)}</span></button>`;

        const types = (sum.byType || []).map((t) =>
            `<option value="${this._esc(t.code)}"${(f.type || '') === t.code ? ' selected' : ''}>
                ${this._esc(t.name)} (${n(t.c)})</option>`).join('');

        $('#dmAuditHead').html(`
            <div class="dm-abar">
                <div class="dm-aprog">
                    <b>${n(s.checked)}</b> / ${n(sum.target)}장 검사함 <span class="text-muted">(${pct}%)</span>
                    ${s.last_at ? `<span class="text-muted ml-2">마지막 ${this._esc(String(s.last_at).substring(0, 16))}</span>` : ''}
                </div>
                <div class="dm-achips">
                    ${chip('', '전체', s.checked, '')}
                    ${chip('masking',   '가림 누락',    s.masking,   'bad')}
                    ${chip('wrongtype', '엉뚱한 서류',  s.wrongtype, 'bad')}
                    ${chip('multidoc',  '여러 장 뭉침', s.multidoc,  'bad')}
                    ${chip('orient',    '방향 틀어짐',  s.orient,    'warn')}
                    ${chip('unknown',   '판단 못 함',   s.unknown,   '')}
                    ${chip('failed',    '검사 못 함',
                           Number(s.nofile || 0) + Number(s.unread || 0) + Number(s.error || 0), '')}
                </div>
                <div class="dm-asels">
                    <select id="dmAuditType" class="form-control form-control-sm dm-asel">
                        <option value="">종류 전체</option>${types}
                    </select>
                    <select id="dmAuditHost" class="form-control form-control-sm dm-asel">
                        ${['', '1', '2', '3'].map((h) =>
                            `<option value="${h}"${(f.host || '') === h ? ' selected' : ''}>${h ? 'w' + h : '서버 전체'}</option>`).join('')}
                    </select>
                </div>
            </div>`);
    }

    _auditColumns() {
        const self = this;
        const V = DocMaster.V;

        // 배지는 **걸린 것만** 그린다. 정상까지 그리면 줄마다 배지가 넷이라 무엇이 문제인지 안 보인다
        const badge = (v, label) =>
            (v === V.VIOLATION || v === V.SUSPECT)
                ? `<span class="dm-abadge dm-abadge--${v === V.VIOLATION ? 'bad' : 'warn'}">${label}</span>` : '';

        return [
            // ⚠ 썸네일이 **안 뜬 것**과 사진이 **없는 것**은 다르다. 빈 칸으로 두면 둘이 같아 보여
            //   "사진도 없는데 판정이 붙었다"로 읽힌다 (실제로 그렇게 보였다).
            //   · 아직 안 뜬 자리 → 점선 자리표시(.dm-athumb--wait)
            //   · 못 불러온 자리 → onerror 로 '사진 못 불러옴'
            //   · 진짜 없는 자리 → '사진 없음'
            //   lazy 는 걷었다 — 한 쪽이 30줄이라 다 받아도 되고, 스크롤 전에 비어 보이는 값이 크다
            { data: null, title: '사진', className: 'dm-athumb', width: '90px', render: (d) =>
                d.thumb ? `<span class="dm-athumb--wait"><img src="${self._esc(d.thumb)}" alt=""></span>`
                        : '<span class="dm-anoimg">사진 없음</span>' },

            { data: null, title: '서류 · 대상', width: '280px', render: (d) => `
                <b>${self._esc(d.typeName)}</b>
                ${d.pageNo > 1 ? `<span class="text-muted">· ${d.pageNo}장째</span>` : ''}
                ${d.isMasked ? '<span class="dm-abadge dm-abadge--ok">가림 표시</span>' : ''}
                <div class="dm-asub">${self._esc(d.name)} <span class="text-muted">${self._esc(d.sub)}</span>
                    ${d.ownerName ? `<span class="text-muted">· ${self._esc(d.ownerName)}</span>` : ''}</div>` },

            { data: null, title: '판정', render: (d) => {
                // 검사는 됐는데 **지금은 사진을 찾을 수 없는** 줄 — 검사한 뒤 회원이 사진을 바꾸거나
                // 지웠다는 뜻이다. 판정 자체는 그때의 사실이라 지우지 않지만, 옆 칸이 '사진 없음'
                // 인데 판정만 붙어 있으면 "사진도 없이 판정했다"로 읽힌다. 무엇의 판정인지 적는다.
                const stale = d.status === 1 && !d.thumb
                    ? '<div class="dm-asub dm-astale">지금은 사진이 없습니다 — 아래는 <b>검사 당시 사진</b> 기준입니다</div>'
                    : '';
                if (d.status !== 1) {
                    const why = d.status === 2 ? '파일 없음' : d.status === 3 ? '글자 못 읽음' : '오류';
                    return `<span class="dm-abadge">${why}</span>`
                         + (d.note ? `<div class="dm-asub text-muted">${self._esc(d.note)}</div>` : '');
                }
                const badges = [
                    badge(d.masking,   '가림 누락'),
                    badge(d.wrongtype, '엉뚱한 서류'),
                    badge(d.multidoc,  '여러 장 뭉침'),
                    badge(d.orient,    `${d.angle || ''}도 틀어짐`),
                ].filter(Boolean).join('') || '<span class="dm-abadge dm-abadge--ok">이상 없음</span>';

                // 표제어가 그 종류와 다르게 걸렸으면 **무엇으로 읽혔는지**를 보여 준다.
                // "엉뚱하다"만 알려 주면 관리자가 사진을 열기 전에는 판단할 수 없다
                const hits = (d.hits || []).filter((h) => h !== d.typeCode);
                return stale + badges + (hits.length
                    ? `<div class="dm-asub">읽힌 서류: <b>${self._esc(hits.join(', '))}</b></div>` : '');
            } },

            { data: null, title: '검사', className: 'text-right dm-awhen', width: '130px', render: (d) =>
                `${self._esc(d.checkedAt)}<br><span class="text-muted">w${self._esc(d.host)} · ${d.textLen}자</span>` },
        ];
    }

    /**
     * 사진 크게 보기 — **지금 쪽에 뜬 장 전부**를 넘겨 좌우로 넘길 수 있게 한다.
     *
     * 한 장만 넘기면 화살표가 안 뜬다(뷰어가 `items.length > 1` 일 때만 그린다). 검사 결과는
     * 여러 장을 연달아 보는 일이라, 한 장 보고 닫고 다시 여는 것이 곧 일의 속도가 된다.
     * 사진이 없는 줄(파일없음)은 빼고 담는다 — 넘기다 빈 화면이 나오면 고장으로 보인다.
     */
    _openAuditPhoto(r) {
        if (!r || !r.url || !this.$audit) return;

        // ⚠ `rows({page:'current'})` 를 쓰면 **2쪽부터 0건**이 나온다. 서버사이드에서는 그 선택자가
        //   전체 기준 시작번호(30, 60 …)로 잘라내는데 손에 든 것은 그 쪽 30줄뿐이라 범위 밖이 된다.
        //   서버사이드는 애초에 **지금 쪽만** 들고 있으므로 선택자 없이 rows() 가 곧 지금 쪽이다.
        //   (1쪽에서만 사진이 열리던 원인 — 2026-09-22)
        const rows = this.$audit.rows().data().toArray().filter((d) => d.url);
        const items = rows.map((d) => {
            const det = [];
            if (d.angle) det.push(`${d.angle}도 틀어짐`);
            const hits = (d.hits || []).filter((h) => h !== d.typeCode);
            if (hits.length) det.push(`읽힌 서류 ${hits.join(', ')}`);
            det.push(`검사 ${d.checkedAt}`);
            return {url: d.url, caption: `${d.typeName} · ${d.name}`, meta: det.join(' · ')};
        });

        const at = rows.findIndex((d) => d.page === r.page);
        // 전체화면이 아니라 상자로 연다 — 목록의 어느 줄을 보고 있었는지가 뒤에 남아야
        // 여러 장을 연달아 확인할 수 있다
        $j.Ui.ZoomPhoto.open(null, {items, index: at < 0 ? 0 : at, size: 'fit'});
    }
}
